<template>
  <div>
    <iframe :id="iframeId" :src="iframeSrc" style="display: none" @load="publisher" />
  </div>
</template>

<script>
export default {
  name: 'BasePublisher',
  props: {
    siteKey: {
      type: String,
      required: true
    },
    origin: {
      type: String,
      required: true
    }
  },
  computed: {
    iframeSrc () {
      return `${this.origin}/user_auths/session.html`
    },
    iframeId () {
      return `session_share_${this.siteKey}`
    }
  },
  methods: {
    publisher () {
      if (this.origin === window.origin) return
      const iframe = document.getElementById(this.iframeId)

      iframe.contentWindow.postMessage(
        `{"key": "vuex", "value": ${localStorage.getItem('vuex')}}`,
        this.origin
      )
    }
  }
}
</script>
